import { render, staticRenderFns } from "./imageCarousel.vue?vue&type=template&id=e8d04e60&"
import script from "./imageCarousel.vue?vue&type=script&lang=js&"
export * from "./imageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e8d04e60')) {
      api.createRecord('e8d04e60', component.options)
    } else {
      api.reload('e8d04e60', component.options)
    }
    module.hot.accept("./imageCarousel.vue?vue&type=template&id=e8d04e60&", function () {
      api.rerender('e8d04e60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2W6Tle6s5Zzth/JS/imageCarousel.vue"
export default component.exports